import { get } from 'lodash';
import React, { useState, useEffect, use } from 'react';
import UnitViewer from 'unit-viewer-react';
function XmlViewer({ appHandle, buildTag, fileArray }) {
    const [xmlReport, setXmlReport] = useState({});
    const [visibleTiles, setVisibleTiles] = useState({});
    const [showTiles, setShowTiles] = useState(true);
    const [fileData, setFileData] = useState([]);
    const domParser = new DOMParser();

    useEffect(() => {
        const getFiles = async () => {
            const fileParams = new URLSearchParams();
            fileParams.append('tag', buildTag);
            fileParams.append('apphandle', appHandle);
            fileParams.append('files', JSON.stringify(fileArray));
            const response = await fetch(`/api/monitoring/devops/tests/retrieve?${fileParams.toString()}`);
            const files = await response.json();
            setFileData(files.files);
        };
        getFiles();
    }, [fileArray]);
    useEffect(() => {
        const loadXunitViewerHtml = async (file, index) => {
            try {
                const xmlText = file.data;
                if (xmlText !== null) {
                    const xmlDoc = domParser.parseFromString(xmlText, 'application/xml');
                    const testsuites = Array.from(xmlDoc.getElementsByTagName('testsuite'));
                    const testSuitesHeader = Array.from(xmlDoc.getElementsByTagName('testsuites'))[0];
                    const name = file.suiteName;
                    const numTests = testSuitesHeader.getAttribute('tests');
                    const numFailures = testSuitesHeader.getAttribute('failures') || 0;
                    const numSkipped = testSuitesHeader.getAttribute('skipped') || 0;
                    const numPassed = numTests - numFailures;
                    const suiteArrayString = testsuites.map(suite => {
                        const xmlSuiteName = suite.getAttribute('name') || 'Unnamed Suite';
                        // Get the raw HTML and sanitize problematic characters
                        let suiteXml = suite.outerHTML;
                        // Remove ANSI color codes that can cause URI issues
                        suiteXml = suiteXml.replace(/\[[\d;]+m/g, '');

                        // Escape percent signs in failure messages to prevent URI malformed errors
                        // Need to do this inside CDATA sections where the percentage appears
                        suiteXml = suiteXml.replace(/(\d+\.\d+)%/g, '$1 percent');

                        return {
                            xmlSuiteName,
                            xml: `<?xml version="1.0" encoding="UTF-8"?>${suiteXml}`,
                        };
                    });

                    const reportData = {
                        suiteName: name,
                        tests: numTests,
                        failures: numFailures,
                        skipped: numSkipped,
                        passed: numPassed,
                        suites: suiteArrayString,
                    };
                    setXmlReport(prev => ({ ...prev, [index]: reportData }));
                } else {
                    const reportData = {
                        suiteName: file.suiteName,
                        text: 'Test suite did not run or closed prematurely. Please see build logs',
                    };
                    setXmlReport(prev => ({ ...prev, [index]: reportData }));
                }
            } catch (err) {
                console.error('Error loading XML report:', err);
            }
        };
        fileData.forEach((file, index) => loadXunitViewerHtml(file, index));
    }, [fileData]);
    // Handle tile visibility toggle
    const handleTileVisibility = (tileId, isVisible) => {
        setVisibleTiles(prev => ({
            ...prev,
            [tileId]: isVisible,
        }));
        setShowTiles(!isVisible);
    };
    return (
        <div>
            {fileData.map((file, index) => {
                if (showTiles) {
                    if (xmlReport[index]?.text) {
                        return (
                            <React.Fragment key={index}>
                                <h2>Test suite: {xmlReport[index]?.suiteName}</h2>
                                <p>{xmlReport[index]?.text}</p>
                            </React.Fragment>
                        );
                    }
                    return (
                        <React.Fragment key={index}>
                            <div onClick={() => handleTileVisibility(index, !visibleTiles[index])}>
                                <h2>Test Suite: {xmlReport[index]?.suiteName}</h2>
                                <p>
                                    Total Tests: {xmlReport[index]?.tests} | Passed: {xmlReport[index]?.passed} |
                                    Failed: {xmlReport[index]?.failures} | Skipped: {xmlReport[index]?.skipped}
                                </p>
                                <button
                                    type="button"
                                    key={`toggle-${index}`}
                                    style={{ margin: '10px auto' }}
                                    onClick={() => handleTileVisibility(index, !visibleTiles[index])}
                                >
                                    Display Test Suite: {file.suiteName}
                                </button>
                            </div>
                        </React.Fragment>
                    );
                }
                if (visibleTiles[index]) {
                    return (
                        <React.Fragment key={index}>
                            <button
                                type="button"
                                key={`toggle-${index}`}
                                style={{ margin: '10px auto' }}
                                onClick={() => handleTileVisibility(index, !visibleTiles[index])}
                            >
                                Hide Test Suite: {file.suiteName}
                            </button>
                            <div>
                                <h2>Test Report for Suite: {xmlReport[index]?.suiteName}</h2>
                                <p>
                                    Total Tests: {xmlReport[index]?.tests} | Passed: {xmlReport[index]?.passed} |
                                    Failed: {xmlReport[index]?.failures} | Skipped: {xmlReport[index]?.skipped}
                                </p>
                                {xmlReport[index]?.suites.map((xmlSuite, suiteIdx) => (
                                    <React.Fragment key={`suite-${index}-${suiteIdx}`}>
                                        <h2 key={`suite-name-${index}-${suiteIdx}`}>
                                            Test Script: {xmlSuite.xmlSuiteName}
                                        </h2>
                                        <div className="unit-viewer-container">
                                            <UnitViewer key={`suite-${index}-${suiteIdx}`} xml={xmlSuite.xml} />
                                        </div>
                                    </React.Fragment>
                                ))}
                            </div>
                        </React.Fragment>
                    );
                }
                return null;
            })}
        </div>
    );
}

export default XmlViewer;
